<template>
  <div class="pane-title">
    <div class="tip-box">
      <div class="up"></div>
      <div class="down"></div>
    </div>
    <div class="en-tit-txt" v-show="lang === 'en'">{{ subTitle.toUpperCase() }}</div>
    <div class="tit-txt" v-show="lang === 'zh'">
      <p>{{ title }}</p>
      <p>{{ subTitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'subTitle'],
  name: "PaneTitle",
  computed: {
    lang() {
      return this.$store.state.mlang;
    }
  }
}
</script>

<style lang="less">
@import "../../../src/common/theme";
.mobile-home {
  .pane-title {
    display: flex;
    margin-bottom: 20px;
    align-items: flex-start;

    .tip-box {
      width: 20px;
      height: 20px;
      position: relative;
      margin-top: 8px;
      margin-right: 7px;

      > * {
        width: 14px;
        height: 14px;
        position: absolute;
      }

      .up {
        background: #037698;
        z-index: 1;
      }

      .down {
        background: #B5E5E7;
        top: 7px;
        left: 7px;
      }
    }
    .en-tit-txt {
      margin-top: 9px;
    }
    .tit-txt {
      p {
        &:nth-child(1) {
          font-size: calc(@mobileFont * .30);
        }
        &:nth-child(2) {
          color: #6e6e6e;
          font-size: calc(@mobileFont * .24);
          font-weight: lighter;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>
